export default __webpack_public_path__ + "static/media/ido-icon.908f1e94.svg";